import script from "./add-estimate.vue?vue&type=script&setup=true&lang=js"
export * from "./add-estimate.vue?vue&type=script&setup=true&lang=js"

import "./add-estimate.vue?vue&type=style&index=0&id=bc511738&lang=css"

const __exports__ = script;

export default __exports__